<template>
<div class="commissionDataList">
    <!-- 标题 -->
    <div class="titleBox flex-row ite-c jus-b">
        <div>
            <b>{{topTitle.title}}</b><span v-show="topTitle.subTit!==''"> - {{topTitle.subTit}}</span>
        </div>
        <div class="exportBtn butStyle" @click="exportData">导出</div>
    </div>


    <!-- 筛选条件 -->
    <div class="searchBox flex-row ite-c jus-b boxs">
        <ul class="colList boxs">
            <li>
                <span class="col-tit2">代理商</span>
                <el-select v-model="searchForm.member_id" class="marRi20" clearable filterable placeholder="请选择代理商">
                    <el-option v-for="item in allAgentOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>

                <span class="col-tit2">套餐</span>
                <el-input v-model="searchForm.package_name" clearable placeholder="输入套餐名称" class="outInput marRi20"></el-input>

            </li>
        </ul>
        <div class="ri-box">
            <button @click="handleSearch" class="butStyle greenBtn searchBtn">
                <i class="el-icon-search"></i>
            </button>
        </div>
    </div>


    <!-- 统计数量 -->
    <ul class="totalBox boxs">
        <li>
          <p class="tbTit">激活总数</p>
          <p class="tbTotal">{{monthlyActivationTotal}}</p>
        </li>
        <li>
          <p class="tbTit">佣金总数（元）</p>
          <p class="tbTotal">{{monthlyCommissionTotal}}</p>
        </li>
    </ul>


    <!-- 数据列表 -->
    <div class="ListBox tableTheadGray boxs">
        <el-table ref="multipleTable" :data="tableData" style="width: 100%" border fit tooltip-effect="dark">
            <el-table-column  min-width="160" prop="data" label="日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column  min-width="180" prop="member_name" label="运营商名称" header-align="center" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column  min-width="180" prop="next_level_member_name" label="下一级代理商" header-align="center" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column  min-width="180" prop="package_name" label="套餐名称" header-align="center" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column  min-width="120" prop="active_count" label="激活数" header-align="center" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column  min-width="130" prop="commission" label="佣金（元）" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
        <div class="pageBox boxs">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.page" :page-sizes="[10, 20, 30]" :page-size="searchForm.size" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>


</div>
</template>

<script>
import {centsToYuan} from '@/utils/unitConverter';
import {
    getCommissionDetailReq, // 统计佣金详情页
    getAllAgentsMap, // 获取指定会员的所有下级代理商
    getMonthlyActivationReq, // 获取月激活数总和
    getMonthlyCommissionReq, // 获取月佣金总和

} from '@/api/Report/Watch/dataReport.js';
import {objectToQueryString} from '@/utils/commonUtils.js';
// 搜索表单的数据
const searchConst = {
    business_type: null,
    month: null,
    member_id: null,
    package_name: null,
    package_id: null,
    self_support: null,
    page: 1, //当前页码
    size: 10, //每页条数
}

export default {
    name: 'commissionDataList',
    data() {
        return {
            //标题
            topTitle: {
                title: '',
                subTit: '佣金统计数据列表'
            },

            // 搜索条件
            searchForm: Object.assign({}, searchConst),
            allAgentOptions: [],// 所有代理商

            // 统计
            monthlyActivationTotal: 0, //本月激活数
            monthlyCommissionTotal: 0, //本月佣金

            tableData: [], // 表格数据
            total: 0, // 表格数据总数

        }
    },
    mounted() {},
    created () {
        // 获取上级页面携带的参数，获取表格数据
        this.initCommissionDataList()
    },
    methods: {
        // 获取上级页面携带的参数，获取表格数据
        initCommissionDataList () {
            console.log('this.$route.query',this.$route.query)
            this.searchForm.business_type = parseInt(this.$route.query.business_type);
            this.searchForm.member_id = this.$route.query.member_id;
            this.searchForm.month = this.$route.query.month;
            this.searchForm.package_id = this.$route.query.package_id;
            this.topTitle.title = this.$route.query.title;
            this.searchForm.package_name = null;
            this.searchForm.self_support = this.$route.query.self_support;
            
            // 获取所有代理商
            this.initAllAgentOptions()

            // 获取当前佣金和激活数的月总数
            this.getAllActiAndCommiData()

            // 获取表格数据
            getCommissionDetailReq(this.searchForm)
                .then(resp => {
                    this.tableData = resp.body.rows
                    this.total = parseInt(resp.body.total)
                })
                .catch(e => console.log(e))
        
        },
        // 获取上级页面携带的参数，获取表格数据
        getCommissionDataList () {
            this.searchForm.package_id = null;
            
            // 获取所有代理商
            this.initAllAgentOptions()

            // 获取当前佣金和激活数的月总数
            this.getAllActiAndCommiData()

            // 获取表格数据
            getCommissionDetailReq(this.searchForm)
                .then(resp => {
                    this.tableData = resp.body.rows
                    this.total = parseInt(resp.body.total)
                })
                .catch(e => console.log(e))
        
        },
        // 获取所有代理商
        initAllAgentOptions() {
            getAllAgentsMap(this.searchForm)
                .then(resp => {
                    this.allAgentOptions = resp
                })
                .catch(e => console.log(e))
        },
        // 获取当前佣金和激活数的月总数
        getAllActiAndCommiData (data) {

            // 激活数请求参数
            var monthSrt = this.searchForm.month;
            var monthFormat = monthSrt.substring(0,4) + '-' + monthSrt.substring(4,6);
            const activationParam = {
                business_type: this.searchForm.business_type,
                member_id: this.searchForm.member_id,
                month: monthFormat,
                package_id: this.searchForm.package_id,
                package_name: this.searchForm.package_name,
                self_support: this.searchForm.self_support
            }
            // 获取月激活数总和
            this.getMonthlyActivation(activationParam)

            // 佣金请求参数
            const commissionParam = {
                business_type: this.searchForm.business_type,
                agent: this.searchForm.member_id,
                max_date: this.searchForm.month,
                package_id: this.searchForm.package_id,
                package_name: this.searchForm.package_name,
                self_support: this.searchForm.self_support
                // product_id: this.product_id,
            }
            // 获取月佣金总和
            this.getMonthlyCommission(commissionParam)
        },
        // 获取月激活数总和
        getMonthlyActivation (data) {
            getMonthlyActivationReq(data).then(response => {
                this.monthlyActivationTotal = response.body.rows[0].num
            }).catch(err => {
                console.log(err);
            })
        },
        // 佣金统计-获取月佣金总和
        getMonthlyCommission (data) {
            getMonthlyCommissionReq(data).then(response => {
                this.monthlyCommissionTotal = centsToYuan(response.body.total_commission)
            }).catch(err => {
                console.log(err);
            })
        },

        // 导出
        exportData() {
            let exportParam = {
                business_type: this.searchForm.business_type,
                month: this.searchForm.month,
                member_id: this.searchForm.member_id,
                package_id: this.searchForm.package_id,
                package_name: this.searchForm.package_name,
                self_support: this.searchForm.self_support
            }
            var url = `${this.$baseUrl}/!Rpt/Watch/DataReport/~java/CommissionStatistics.getCommissionStatisticsDetailExport?${objectToQueryString(exportParam)}`;
            console.log(url);
            window.open(url, '_blank');
        },
        // 列表过滤查询
        handleSearch () {
            this.searchForm.page = 1
            this.getCommissionDataList()
        },
        // 列表每页条数变了
        handleSizeChange (val) {
            this.searchForm.size = val
            this.getCommissionDataList()
        },
        // 列表当前页码变了
        handleCurrentChange (val) {
            this.searchForm.page = val
            this.getCommissionDataList()
        },
    },
}
</script>

<style scoped>
.marRi20{
    margin-right: 20px;
}
.commissionDataList{
    /* width: 100%; */
    min-width: 550px;
}

/* 标题 */
.commissionDataList .titleBox{
     width: 100%;
    background: #ffffff;
    height: 44px;
    padding-left: 9px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
}
.titleBox b{
    color:#333333;
    font-size: 14px;
}
.titleBox b::before{
    content: '';
    display: inline-block;
    height: 19px;
    width: 6px;
    background: #1DB56F;
    margin-right: 10px;
    vertical-align: middle;
}
.titleBox span{
    color:#7F7F7F;
    font-size: 12px;
}
.titleBox .exportBtn{
    color:#FF2A2A;
    font-size: 14px;
    height: 16px;
}
.titleBox .exportBtn::before{
    content: '';
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url('../../../../../assets/images/report/DataReport/export.png') no-repeat;
    background-size: 16px 16px;
    margin-right: 4px;
    vertical-align: middle;
}

/* 筛选条件 */
.searchBox{
    width: 100%;
    padding: 12px;
    margin-top: 10px;
    background: #fff;
    border: 1px solid #E4E4E4;
}
.searchBox .colList {
    width: calc( 100% - 100px);
}
.searchBox .outInput {
    /* width: 25%; */
    max-width: 200px;
}

/* 统计数量 */
.totalBox{
    width: 100%;
    height: 64px;
    /* margin-top: 14px; */
    margin: 14px 0;
}
.totalBox li{
    float: left;
    width: 200px;
    /* min-width: 19%; */
    height: 64px;
    padding: 12px 10px 7px;
    background: #1DB56F;
    color:#FFFFFF;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    border-radius: 5px;
    -o-border-radius: 5px;
    -webkit-border-radius: 5px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
}
.totalBox li+li{
    margin-left: 10px;
}
.totalBox li:nth-child(2){
    background: #FFC400;
}
.totalBox li:nth-child(3){
    background: #A6CEE3;
}
.totalBox li .tbTit{
    font-size: 13px;
    height: 17px;
    line-height: 17px;
}
.totalBox li .tbTotal{
    font-size: 20px;
    height: 26px;
    line-height: 26px;
    text-align: end;
}

/* 数据列表 */
.ListBox{
    width: 100%;
}

/* 分页条 */
.pageBox {
  width: 100%;
  padding: 15px 0 10px;
  display: flex;
  justify-content: flex-end;
  background: #ffffff;
  border: 1px solid #E4E4E4;
  border-top: none;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
</style>
